export default {
    bindings: {
        content: '<'
    },
    controller: 'suggestionsController',
    template: require('../views/suggestions.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/components/suggestions.component.js